<template>
  <div class="setting">
    <div class="currentRoute">
      <div class="route">
        <router-link to="/knowledgebase">知识库</router-link>
      </div>
      <p>/数据集</p>
    </div>
    <div class="header">
      <el-input v-model="searchQuery" placeholder="搜索文件" class="search-input" />
      <el-button type="primary" @click="addFile" class="add-file">新增文件</el-button>
    </div>
    <!-- 文件上传模态框 -->
    <UpLoadCard v-show="showUploadModal" :currentUserId=currentUserId @ifsuccess="updateFiles" :uploadedFiles="files.map(file => file.name)" />
    
    <!-- PC端表格视图 -->
    <el-table v-if="!isMobile" :data="filteredFiles" :border=true class="file-table">
      <el-table-column prop="index" label="序号" width="50" align="center" />
      <el-table-column prop="uploadDate" label="上传日期" width="200" align="center" />
      <el-table-column  prop="name" label="文件名称" width="250" align="center" />
      <el-table-column label="是否启用" width="140" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enabled" @change="toggleEnabled(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column prop="status" label="解析状态" width="120" align="center">
        <template slot-scope="scope">
          <span :style="{ color: getStatusColor(scope.row.status) }">{{ scope.row.status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="500" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="create_VectorDB(scope.row)">解析文件</el-button>
          <el-button size="mini" @click="viewFile(scope.row)">查看</el-button>
          <el-button size="mini" type="danger" @click="deleteFile(scope.row)">删除</el-button>
          <el-button size="mini" @click="renameFile(scope.row)">重命名</el-button>
          <el-button size="mini" @click="downloadFile(scope.row)">下载</el-button>
          <el-button size="mini" @click="view_chunk_file(scope.row)">查看分块</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端卡片视图 -->
    <div v-else class="mobile-file-list">
      <div v-for="file in filteredFiles" :key="file.index" class="mobile-file-card">
        <div class="file-card-header">
          <span class="file-index">#{{ file.index }}</span>
          <el-switch v-model="file.enabled" @change="toggleEnabled(file)" size="small" />
        </div>
        <div class="file-card-name">{{ file.name }}</div>
        <div class="file-card-info">
          <span class="file-date">{{ file.uploadDate }}</span>
          <span class="file-status" :style="{ color: getStatusColor(file.status) }">{{ file.status }}</span>
        </div>
        <div class="file-card-actions">
          <el-button size="mini" @click="create_VectorDB(file)">解析</el-button>
          <el-button size="mini" @click="viewFile(file)">查看</el-button>
          <el-button size="mini" type="danger" @click="deleteFile(file)">删除</el-button>
          <el-button size="mini" @click="renameFile(file)">重命名</el-button>
          <el-button size="mini" @click="downloadFile(file)">下载</el-button>
          <el-button size="mini" @click="view_chunk_file(file)">分块</el-button>
        </div>
      </div>
      <div v-if="filteredFiles.length === 0" class="no-files">
        暂无文件
      </div>
    </div>

    <div class="pagination">
      <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
        layout="prev, pager, next" :total="files.length" />
    </div>
    <div v-if=showDeleteWarning class="deleteChatWarning">
      <WarningCard @confirm="verifyDeleteFile" warningMessage="确定删除该文件？" />
    </div>
    <div v-show="showInputCard" class="inputCard">
      <InputCard inputMessage="请输入文件名" @confirm="verifyUpdateFilename" />
    </div>
  </div>
</template>

<script>

import UpLoadCard from '../components/UpLoadCard.vue';
import { getKbFiles, deleteKbFile, updateKbFileName, downloadKbFile, viewKbFile, writekbfileConfig, createVectorDB, getkbConfig,viewchunkFile } from '../../api/auth';
import WarningCard from '../pannels/WarningCard.vue';
import InputCard from '../pannels/InputCard.vue';

export default {
  name: 'KbDataPage',
  components: {
    UpLoadCard,
    WarningCard,
    InputCard
  },

  mounted() {
    this.updateFiles(true);
    console.log('当前用户ID', this.currentUserId);
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  data() {
    return {
      searchQuery: '',
      files: [
        // 示例数据
        // { index: 1, uploadDate: '2023-10-01', name: '文件1', enabled: true, status: '解析成功' },
        // { index: 2, uploadDate: '2023-10-02', name: '文件2', enabled: false, status: '解析中' },
        // 更多文件数据...
      ],
      currentPage: 1,
      pageSize: 10,
      showUploadModal: false,
      selectedFile: null,
      showDeleteWarning: false,
      showInputCard: false,
      isMobile: false
    };
  },
  computed: {
    filteredFiles() {
      return this.files
        .filter(file => file.name.includes(this.searchQuery))
        .slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.files.length / this.pageSize);
    },

  },
  props: {
    currentUserId: {
      type: String,
      required: true
    },
  },
  methods: {
    // 监听窗口大小变化
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    // 获取状态颜色
    getStatusColor(status) {
      switch (status) {
        case '解析成功':
          return 'green';
        case '解析中':
          return 'orange';
        case '解析失败':
          return 'red';
        default:
          return 'black';
      }
    },
    //翻页
    handlePageChange(val) {
      this.currentPage = val;
    },
    create_VectorDB(file) {
      // 创建向量数据库逻辑
      getkbConfig(this.currentUserId, this.$route.params.folderName).then((res) => {
        console.log('获取知识库配置文件', res);
        file.config.ifVectorDB = 0; // 0代表解析中,-1代表解析失败，1代表解析成功
            writekbfileConfig(this.currentUserId, this.$route.params.folderName, file.name, file.config).then((res) => {
              console.log('写入文件配置', res);
              this.updateFiles(true);
            })

        createVectorDB(this.currentUserId, this.$route.params.folderName, file.name, res.data.config,file.fileType).then((res) => {
          console.log('创建向量数据库', res);
          this.updateFiles(true);
        }).catch((err) => {
          console.log('创建向量数据库失败', err);          
          this.updateFiles(true);
        })
        });
      
    },
    updateFiles(ifsuccess) {
      if (ifsuccess) {
        getKbFiles(this.currentUserId, this.$route.params.folderName).then((res) => {
          console.log('获取文件列表', res);
          this.files = [];
          for (let i = 0; i < res.length; i++) {
            this.files.push({
              index: i + 1,
              uploadDate: this.formatTime(res[i].creationTime),
              name: res[i].name.split('%').length > 1 ? res[i].name.split('%')[1] : res[i].name,
              enabled: res[i].config.ifUse,
              status:this.getAnalysisStatus(res[i].config.ifVectorDB) ,
              fileType: res[i].config.fileType,
              config: res[i].config
            });
          }
         })

      }


    },
    getAnalysisStatus(ifvectorDB) {
      // 获取解析状态逻辑
      switch (ifvectorDB) {
        case 1:
          return '解析成功';
        case 0:
          return '解析中';
        case -1:
          return '解析失败';
        default:
          return '未解析';
      }

    },
    formatTime(originalTime) {
      //const date = new Date(originalTime);
      const date = new Date(originalTime * 1000);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始，所以需要加1
      const day = date.getDate();
      return `${year}-${month}-${day}`;
    },
    addFile() {
      // 新增文件逻辑
      this.showUploadModal = true;
    },
    toggleEnabled(file) {
      // 切换启用状态逻辑
      file.config.ifUse = file.enabled;
      writekbfileConfig(this.currentUserId, this.$route.params.folderName, file.name, file.config).then((res) => {
        console.log('写入文件配置', res);
      })
    },
    viewFile(file) {
      // 查看文件逻辑
      viewKbFile(this.currentUserId, this.$route.params.folderName, file.name,file.config.fileType);
    },
    view_chunk_file(file) {
      // 查看文件片段逻辑
      viewchunkFile(this.currentUserId, this.$route.params.folderName, file.name);
    },
    verifyDeleteFile(ifDelete) {
      // 确认删除文件逻辑
      if (ifDelete) {
        deleteKbFile(this.currentUserId, this.$route.params.folderName, this.selectedFile);
        this.selectedFile = null;
        this.updateFiles(true);
      }
      this.showDeleteWarning = false;
    },

    deleteFile(file) {
      // 删除文件逻辑
      this.showDeleteWarning = true;
      this.selectedFile = file.name;
    },

    renameFile(file) {
      // 重命名文件逻辑
      this.showInputCard = true;
      this.selectedFile = file.name;
    },
    verifyUpdateFilename(ifupdate, newTitle) {
      // 确认修改文件名逻辑
      if (ifupdate) {
        updateKbFileName(this.currentUserId, this.$route.params.folderName, this.selectedFile, newTitle);
        this.selectedFile = null;
        this.updateFiles(true);
      }
      this.showInputCard = false;

    },
    downloadFile(file) {
      // 下载文件逻辑
      downloadKbFile(this.currentUserId, this.$route.params.folderName, file.name,file.fileType);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  }
};
</script>

<style scoped>
.setting {
  padding: 20px;
}

.currentRoute {
  display: flex;
  font-size: 20px;
  font-size: 24px;
  margin-bottom: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.search-input {
  width: 300px;
  max-width: 100%;
}

.add-file {
  white-space: nowrap;
}

.file-table {
  width: 100%;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.el-table__header-wrapper {
  width: 1100px;
}

/* 移动端卡片样式 */
.mobile-file-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-file-card {
  background: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.file-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.file-index {
  font-size: 14px;
  color: #999;
  font-weight: 500;
}

.file-card-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  word-break: break-all;
  margin-bottom: 10px;
}

.file-card-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.file-date {
  color: #666;
}

.file-status {
  font-weight: 500;
}

.file-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.file-card-actions .el-button {
  margin: 0;
  flex: 1;
  min-width: 60px;
}

.no-files {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
}

/* 移动端响应式样式 */
@media screen and (max-width: 768px) {
  .setting {
    padding: 10px;
  }

  .currentRoute {
    position: relative;
    top: auto;
    left: auto;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .header {
    flex-direction: column;
    align-items: stretch;
  }

  .search-input {
    width: 100%;
  }

  .add-file {
    width: 100%;
  }

  .pagination {
    margin-top: 15px;
  }

  .file-card-actions {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }

  .file-card-actions .el-button {
    font-size: 12px;
    padding: 7px 10px;
  }
}

@media screen and (max-width: 480px) {
  .file-card-actions {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>